import { render, staticRenderFns } from "./expansion.vue?vue&type=template&id=29d9abff&scoped=true&"
import script from "./expansion.vue?vue&type=script&lang=js&"
export * from "./expansion.vue?vue&type=script&lang=js&"
import style0 from "./expansion.vue?vue&type=style&index=0&id=29d9abff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d9abff",
  null
  
)

export default component.exports